import { Injectable } from '@angular/core';
import { IUiNotificationService } from '../interfaces';
import { UiNotificationType } from '../models';
import Swal from "sweetalert2";
import { SweetAlertResult } from "sweetalert2";
import { Observable, from, map, } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UiNotificationService implements IUiNotificationService {

    public showNotification(type: UiNotificationType, content: string, errors: Array<string> = []): void {
        if (type == UiNotificationType.Success) {
            Swal.fire({
                icon: 'success',
                title: content,
                html: this.displayErrors(errors)
            });
        }
        else if (type == UiNotificationType.Info) {
            Swal.fire({
                icon: 'info',
                title: content,
                html: this.displayErrors(errors)
            });
        }
        else if (type == UiNotificationType.Warning) {
            Swal.fire({
                icon: 'warning',
                title: content,
                html: this.displayErrors(errors)
            });
        }
        else if (type == UiNotificationType.Error) {
            Swal.fire({
                icon: 'error',
                title: content,
                html: this.displayErrors(errors)
            });
        }
    }

    public showConfirmation(content: string): Observable<boolean> {
        return from(
            Swal.fire({
                title: 'Are you sure?',
                text: content,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#0082ca',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Confirm'
            }))
            .pipe(
                map((result: SweetAlertResult<boolean | undefined>) => {
                    return result?.value || false;
                })
            );
    }

    private displayErrors = (arr: string[]) => {
        let errorItems = "";
        arr.forEach(item => {
            errorItems += '<p>' + item + '</p>'
        })
        return errorItems
    }
}
